export default __webpack_public_path__ + "static/media/day7.595c5369.png";